export default {"src":"/_next/static/media/yazd.16bbe88c.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};